import React from "react";
import Button from '../../components/Button';

const QuantitySelector = ({
  mobile,
  price,
  itemCount,
  extraItemPrice,
  onAdd,
  addToBasket,
  onRemove,
  currecyDescription,
  currencyPrecision,
  originalPrice,
  existingItem,
  isOpenCategory,
  integerPrice,
}) => {
  const totalPrice = (itemCount * price + extraItemPrice).toFixed(2);
  if (mobile) {
    const buttonName = existingItem ? "UPDATE" : "ADD";
    return (
      <div
        className="ls-quantity-selector-mobile"
        style={{ backgroundColor: !isOpenCategory ? "#909ca2" : null }}
      >
        <div>
          <button
            type="button"
            disabled={itemCount === 1}
            onClick={() => (isOpenCategory ? onRemove() : null)}
          >
            -
          </button>
        </div>
        <div>
          <span>{itemCount}</span>
          <div />
        </div>
        <div>
          <button
            type="button"
            onClick={() => (isOpenCategory ? onAdd() : null)}
          >
            +
          </button>
        </div>
        <div onClick={isOpenCategory ? addToBasket : null}>
          <div>
            {currecyDescription} &nbsp;
            {`${totalPrice}`}
          </div>
        </div>
        <div onClick={isOpenCategory ? addToBasket : null}>{buttonName}</div>
      </div>
    );
  }

  return (
    <div className="ls-quantity-selector">
      <div className="ls-quantity-selector-price">
        <span
          className="ls-quantity-selector-last-price"
          style={{ marginRight: "5px" }}
        >
          {currecyDescription}
          {` ${price &&
            (integerPrice / 10 ** currencyPrecision).toFixed(
              currencyPrecision
            )}`}
        </span>
      </div>
    </div>
  );
};

export default QuantitySelector;
